import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
  Edit_Cuisine_List_Item_PUT,
  Get_Cuisine_List_Item_GET,
  Save_Cuisine_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import ImageSelector from "components/common/ImageSelector";
import ModalWrapper from "components/common/ModalWrapper";
import React, { useEffect, useState } from "react";

import toast from "react-hot-toast";
import { MODAL_LOADER } from "utils/constants";
import { isEmpty } from "utils/TextUtils";

const CuisineAddEdit = ({ show, hideModal, recordID, handleRefresh }) => {
  const [record, setRecord] = useState({
    cuisineTitle: "",
    imageRefId: "",
  });

  const checkInputValidation = () => {
    if (isEmpty(record.cuisineTitle)) {
      toast.error("Cuisine Title must not be empty.", {
        id: "restaurantTitle",
      });
      return;
    } else if (isEmpty(record.imageRefId)) {
      toast.error("Image must not be empty.", {
        id: "addressLine",
      });
      return;
    }
    return true;
  };

  const handleSubmit = () => {
    try {
      if (!checkInputValidation()) {
        return;
      }
      if (recordID) {
        // update
        callPutApi(
          MODAL_LOADER,
          Edit_Cuisine_List_Item_PUT.replace("{uuid}", recordID),
          record,
          {},
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          }
        );
      } else {
        // Create
        callPostApi(
          MODAL_LOADER,
          Save_Cuisine_List_Item_POST,
          record,
          {},
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    recordID &&
      callGetApi(
        MODAL_LOADER,
        Get_Cuisine_List_Item_GET.replace("{uuid}", recordID),
        {},
        (res) => {
          setRecord({
            cuisineTitle: res.responsePacket.cuisineTitle,
            imageRefId: res.responsePacket.imageRefId,
          });
        }
      );
  }, [recordID]);

  const handleGameIconChange = (imageRefId) => {
    setRecord({ ...record, imageRefId: imageRefId });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRecord({ ...record, [name]: value });
  };
  return (
    <>
      <ModalWrapper
        show={show}
        hide={hideModal}
        header={`${recordID ? "Update" : "Add"}`}
        handleSubmit={handleSubmit}
      >
        <div className="container">
          <div className="row">
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Cuisine Name
              </label>
              <input
                type="text"
                className="form-control"
                value={record.cuisineTitle}
                name="cuisineTitle"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            <div className="mb-3">
              <ImageSelector
                style={{
                  height: "120px",
                  width: "120px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                }}
                user={true}
                handleImageChange={handleGameIconChange}
                selectedImage={record.imageRefId}
              />
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default CuisineAddEdit;
